import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import PropTypes from 'prop-types';
import QRCodeImage from '../../assets/QRCode_Facil.png';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    fontFamily: 'Helvetica',
    color: '#333',
    backgroundColor: '#f9f9f9',
  },
  header: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: 1.5,
    color: '#2c3e50',
  },
  section: {
    marginBottom: 20,
    padding: 16,
    border: '1pt solid #ddd',
    borderRadius: 8,
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#2c3e50',
    borderBottom: '2pt solid #2c3e50',
    paddingBottom: 5,
    textTransform: 'uppercase',
  },
  field: {
    fontSize: 11,
    marginBottom: 6,
    color: '#444',
    lineHeight: 1.6,
  },
  boldText: {
    fontWeight: 'bold',
    color: '#000',
  },
  qrCodeSection: {
    fontSize: 10,
    textAlign: 'center',
    marginTop: 30,
  },
  qrCodeImage: {
    width: 80,
    height: 80,
    marginBottom: 10,
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 40,
    right: 40,
    fontSize: 10,
    textAlign: 'center',
    color: '#666',
  },
  signatureLine: {
    marginTop: 30,
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    width: '70%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  signatureText: {
    marginTop: 10,
    textAlign: 'center',
    fontSize: 12,
  },
});

const AtestadoMedicoPDF = ({ data }) => {
  const {
    nomePaciente,
    dataEmissao,
    cid,
    diasAfastamento,
    assinaturaDigital,
    observacoes,
    localAtendimento,
    nomeMedico,
    crmMedico,
    estadoCRM,
  } = data;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text>Atestado Médico</Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Dados do Paciente</Text>
          <Text style={styles.field}>
            <Text style={styles.boldText}>Nome:</Text> {nomePaciente}
          </Text>
          <Text style={styles.field}>
            <Text style={styles.boldText}>Data de Emissão:</Text> {dataEmissao}
          </Text>
          <Text style={styles.field}>
            <Text style={styles.boldText}>CID:</Text> {cid}
          </Text>
          <Text style={styles.field}>
            <Text style={styles.boldText}>Período de Afastamento:</Text>{' '}
            {diasAfastamento} dias
          </Text>
          {observacoes && (
            <Text style={styles.field}>
              <Text style={styles.boldText}>Observações:</Text> {observacoes}
            </Text>
          )}
          <Text style={styles.field}>
            <Text style={styles.boldText}>Local de Atendimento:</Text>{' '}
            {localAtendimento}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Dados do Médico</Text>
          <Text style={styles.field}>
            <Text style={styles.boldText}>Nome:</Text> {nomeMedico}
          </Text>
          <Text style={styles.field}>
            <Text style={styles.boldText}>CRM:</Text> {crmMedico} - {estadoCRM}
          </Text>
        </View>

        <View style={styles.qrCodeSection}>
          <Image style={styles.qrCodeImage} src={QRCodeImage} />
          <Text>Valide este atestado utilizando o QR Code acima</Text>
        </View>

        <View style={styles.signatureLine}></View>
        <Text style={styles.signatureText}>Assinatura Digital</Text>
        <Text style={styles.signatureText}>{assinaturaDigital}</Text>

        <View style={styles.footer}>
          <Text>
            Este documento foi gerado eletronicamente e é válido sem a
            necessidade de uma assinatura física.
          </Text>
          <Text>
            Verifique a autenticidade deste atestado em
            https://plantao.prontuariofacil.com.br/verificar-atestado
          </Text>
          <Text>
            Documento assinado digitalmente conforme a Medida Provisória nº
            2.200-2/2001 que institui a Infraestrutura de Chaves Públicas
            Brasileira (ICP-Brasil).
          </Text>
        </View>
      </Page>
    </Document>
  );
};
AtestadoMedicoPDF.propTypes = {
  data: PropTypes.shape({
    nomePaciente: PropTypes.string.isRequired,
    dataEmissao: PropTypes.string.isRequired,
    cid: PropTypes.string.isRequired,
    diasAfastamento: PropTypes.number.isRequired,
    assinaturaDigital: PropTypes.string.isRequired,
    observacoes: PropTypes.string,
    localAtendimento: PropTypes.string.isRequired,
    nomeMedico: PropTypes.string.isRequired,
    crmMedico: PropTypes.string.isRequired,
    estadoCRM: PropTypes.string.isRequired,
  }).isRequired,
};

export default AtestadoMedicoPDF;
